import { render, staticRenderFns } from "./EvolutionTableDataRow.vue?vue&type=template&id=6124bcd2&scoped=true"
import script from "./EvolutionTableDataRow.vue?vue&type=script&lang=js"
export * from "./EvolutionTableDataRow.vue?vue&type=script&lang=js"
import style0 from "./EvolutionTableDataRow.vue?vue&type=style&index=0&id=6124bcd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6124bcd2",
  null
  
)

export default component.exports